import { Globals } from "./Globals";
import { QHighlight } from "./QHighlight";
import { QUserMgmtRFC } from "./QUserMgmtRFC";
import { QXMLObject } from "./QXMLObject";

export class QHighlightMgr extends QXMLObject {
  constructor() {
    super();
    this.fParentClass = null;
    this.fHighlightList = null;
    this.fInteractiveHighlight = null;
    this.fSharedHighlights = [];
    this.fHighlightGroup = [];
    this.fKey = "highlights";
  }

  GetWSMgr() {
    var parentClass = this.fParentClass;
    if (parentClass) {
      var objMgr = parentClass.fObjMgr;
      if (objMgr.fClass) {
        var oClass = objMgr.fClass;
        if (oClass) return oClass.fWSMGr;
      }
    }
    return null;
  }

  HasSavedHighlightsApplied() {
    var highlights = this.fHighlightList;
    if (!highlights) return false;
    return highlights.some(highlight => highlight.GetFilterApplied());
  }

  GetNumberOfSavedHighlightsApplied() {
    const highlights = this.fHighlightList || [];
    return highlights.filter(highlight => highlight.GetFilterApplied()).length;
  }

  GetNumberOfHighlightsApplied() {
    const savedHighlights = this.fHighlightList;
    const interactiveHighlights = this.fInteractiveHighlight;
    const sharedHighlights = this.fSharedHighlights;

    const highlights = [
      ...(savedHighlights || []),
      ...(interactiveHighlights || []),
      ...(sharedHighlights || [])
    ];
    return highlights.filter(highlight => highlight.GetFilterApplied()).length;
  }

  GetFilterGroupIdentifier(altDoc = null) {
    var wsMgr = this.GetWSMgr();
    if (wsMgr == null) return "charts";
    const doc = altDoc || wsMgr.GetDoc();
    if (doc == null) return "charts";

    var chartID = doc.GetChartID();
    var org = wsMgr.GetAccountName();
    var user = wsMgr.GetUserName();

    return org + "_" + user + "_" + chartID;
  }

  InitHighlightMgr(parentClass) {
    this.fParentClass = parentClass;
    this.fHighlightList = []; //List of saved JS highlights - from chart metadata.
    this.fHighlightGroup = []; //List of user highlights from local storage.
    this.SetXMLElementName("highlightmgr");
  }

  GetNumHighlights() {
    return this.fHighlightList.length;
  }

  GetNumAllowedHighlights() {
    return this.GetAllowedHighlightList().length;
  }

  GetNameHighlight(name) {
    var highlightList = this.fHighlightList;
    for (var highlightIdx in highlightList) {
      var theHighlight = highlightList[highlightIdx];
      if (theHighlight.fName === name) return theHighlight;
    }
    return null;
  }

  RemoveFilter(aHighlight) {
    var index = this.fHighlightList.indexOf(aHighlight);
    if (index != -1) {
      this.fHighlightList.splice(index, 1);
    }
    return index;
  }

  AddHighlight(aHighlight) {
    this.fHighlightList.push(aHighlight);
  }

  ResetHighlightMgr() {
    this.fHighlightList = [];
    this.fHighlightGroup = [];
    this.fInteractiveHighlight = [];
    this.fSharedHighlights = [];
  }

  GetInteractiveHighlights() {
    return this.fInteractiveHighlight;
  }

  SetInteractiveHighlights(interactiveHighlight) {
    this.fInteractiveHighlight = interactiveHighlight;
  }

  GetSharedHighlights() {
    return this.fSharedHighlights || [];
  }

  SetSharedHighlights(sharedHighlights) {
    this.fSharedHighlights = sharedHighlights || [];
  }

  HasActiveIH() {
    var interactiveHighlights = this.GetInteractiveHighlights();
    if (interactiveHighlights == null) return false;

    return interactiveHighlights.some(ih => ih.fActive && ih.fDef);
  }

  LoadFromJSON(json) {
    this.fHighlightList = [];
    var highlights = json["highlights"];

    for (var i = 0; i < highlights.length; i++) {
      var indexHighlight = highlights[i];
      var newHighlight = new QHighlight();
      newHighlight.DoInitHighlight();
      newHighlight.LoadFromJSON(indexHighlight);
      this.AddHighlight(newHighlight);
    }
  }

  // Output persistent member variables
  OutputToJSON(stream) {
    //TODO
    var hMgr = {};
    var n = this.GetNumHighlights();
    hMgr["highlights"] = [];
    for (var i = 0; i < n; i++) {
      var indexHighlight = this.GetIndexHighlight(i);
      hMgr["highlights"].push(indexHighlight.OutputToJSON(stream));
    }
    return hMgr;
  }

  // Output persistent child objects
  OutputChildElements(stream) {
    var n = this.GetNumHighlights();
    for (var i = 0; i < n; i++) {
      var indexFilter = this.GetIndexHighlight(i);
      indexFilter.OutputToXML(stream);
    }
  }

  // Load from storage
  LoadSubElements(objTree) {}

  LoadChildElements(objTree) {
    var childList = objTree.GetNumChildren();
    for (var i = 0; i < childList; i++) {
      var highlightInfo = objTree.GetIndexChild(i);
      var aHighlight = new QHighlight();
      aHighlight.DoInitHighlight();
      aHighlight.LoadFromXML(highlightInfo);
      this.fHighlightList.push(aHighlight);
    }
  }

  GetHighlights() {
    return this.fHighlightList;
  }

  GetAllowedHighlightList() {
    const highlightList = this.GetHighlights();
    const wsMgr = this.GetWSMgr();
    const myGroup = wsMgr.GetCurrentUserGroup();
    const doc = wsMgr.GetDoc();
    const myChartID = doc.GetChartID();

    return highlightList.filter(function (item) {
      return (
        !myGroup ||
        !myGroup["fAllowedHighlights"] ||
        !myGroup["fAllowedHighlights"][myChartID] ||
        myGroup["fAllowedHighlights"][myChartID].indexOf(item.fName) > -1
      );
    });
  }

  AllowedChartHighlightList(chartHighlightList) {
    var allowedNames = this.GetAllowedHighlightList().map(function (x) {
      return x.fName;
    });
    return chartHighlightList.filter(function (chartHighlight) {
      return allowedNames.indexOf(chartHighlight.name) > -1;
    });
  }

  GetShownHighlights() {
    return this.GetAllowedHighlightList().filter(function (highlight) {
      return !highlight.fHidden;
    });
  }

  CloneHighlightList() {
    var highlightList = [];
    var n = this.GetNumHighlights();
    for (var i = 0; i < n; i++) {
      var aHighlight = this.GetIndexHighlight(i);
      var cHighlight = aHighlight.Clone();
      highlightList.push(cHighlight);
    }
    return highlightList;
  }

  FindNameMatch(aHighlight, highlightList) {
    var n = highlightList.length;
    var highlightName = aHighlight.GetName();
    for (var i = 0; i < n; i++) {
      var cHighlight = highlightList[i];
      var cName = cHighlight.GetName();
      if (cName == highlightName) return cHighlight;
    }

    return null;
  }

  SyncHighlights(highlightList) {
    var n = this.GetNumHighlights();
    for (var i = 0; i < n; i++) {
      var aHighlight = this.GetIndexHighlight(i);
      var cHighlight = this.FindNameMatch(aHighlight, highlightList);
      if (cHighlight) aHighlight.fActive = cHighlight.fActive;
    }
  }

  GetHighlightIndex(aHighlight) {
    return this.fHighlightList.indexOf(aHighlight);
  }

  ShuffleHighlight(aHighlight, shuffleUp) {
    var index = this.GetHighlightIndex(aHighlight);
    var n = this.GetNumHighlights();
    var newIndex = index;

    if (shuffleUp) newIndex = index - 1;
    else newIndex = index + 1;

    if (newIndex < 0) return;
    if (newIndex >= n) return;

    var t = this.fHighlightList[newIndex];
    this.fHighlightList[newIndex] = aHighlight;
    this.fHighlightList[index] = t;
    /*
    var theDoc = this.GetDoc();
    if (theDoc)
        theDoc.SetDirty(true);
	*/
  }

  GetFullGroupList() {
    const userDBHighlights = this.GetWSMgr()?.GetUserInfo()?.fChartRules?.highlights;

    if (userDBHighlights) {
      return userDBHighlights.map(obj => {
        const highlight = new QHighlight();
        highlight.LoadFromJSON(obj);
        return highlight;
      });
    }

    // Local storage fallback
    const rawHighlights = userDBHighlights ?? JSON.parse(localStorage["highlightgroup"] || "[]");
    const highlights = [];

    const modernHighlights = rawHighlights.forEach(obj => {
      if (typeof obj === "string") {
        const highlight = new QHighlight();
        highlight.LoadFromJSON(JSON.parse(obj));
        highlights.push(highlight);
      } else if (Array.isArray(obj?.highlights)) {
        // Legacy highlights
        const existingNames = new Set(highlights.map(h => h.fName));
        const existingUID = new Set(highlights.map(h => h.fUID));
        obj.highlights.forEach((hl, index) => {
          const highlight = new QHighlight();
          highlight.LoadFromLocalStorageObject(obj, hl);

          // Ensure unique names and Filter IDs
          if (existingNames.has(highlight.fName)) {
            let nameIndex = 0;
            while (true) {
              const proposedName = `${highlight.fName} (${index + nameIndex})`;
              if (!existingNames.has(proposedName)) {
                highlight.fName = proposedName;
                break;
              }
              nameIndex++;
            }
          }

          if (existingUID.has(highlight.fUID)) {
            const proposedUID = Math.max(0, ...existingUID) + 1;
            highlight.fUID = proposedUID;
          }

          highlights.push(highlight);
          existingNames.add(highlight.fName);
          existingUID.add(highlight.fUID);
        });
      }
    });

    return highlights;
  }

  GetIndexHighlight(aHighlight) {
    return this.fHighlightList[aHighlight];
  }

  PersistUserHighlights(newHighlights) {
    QUserMgmtRFC.UpdateChartRules(this.GetWSMgr(), {
      highlights: newHighlights ? newHighlights.map(h => h.OutputToJSON()) : []
    });
  }
}
